<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Custom Requests
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'requests-index' })">
            <i class="fa fa-pencil"></i> Custom Requests
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header">
          <div class="box-title">
            <h3>Custom Requests</h3>
          </div>
        </div>

        <div class="box-body table-responsive">
          <table class="table table-hover">
            <transition name="fade" mode="out-in">
              <tbody v-if="isLoading" key="loading">
                <tr>
                  <td>
                    <h3>Loading</h3>
                  </td>
                </tr>
              </tbody>

              <tbody v-else-if="!isLoading && items.length < 1" key="empty">
                <tr>
                  <td>
                    <h3>Empty</h3>
                  </td>
                </tr>
              </tbody>

              <tbody v-else key="data">
                <tr>
                  <th style="min-width: 12rem">Created</th>
                  <th style="min-width: 16rem">Name</th>
                  <th style="min-width: 16rem">Email</th>
                  <th style="min-width: 12rem">Phone</th>
                  <th style="min-width: 12rem">Type</th>
                  <th style="min-width: 12rem">Destination</th>
                  <th style="min-width: 12rem">Starting City</th>
                  <th class="text-center" style="min-width: 12rem">Departure</th>
                  <th class="text-center" style="min-width: 12rem">Return</th>
                  <th class="text-center" style="min-width: 6rem">Adult</th>
                  <th class="text-center" style="min-width: 6rem">Children</th>
                  <th style="min-width: 12rem">Budget</th>
                  <th class="text-center" style="min-width: 12rem">Action</th>
                </tr>

                <tr v-for="(item, index) in items" :key="index">
                  <td>{{ parseDate(item.created_at) }}</td>
                  <td>{{ item.full_name }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.type_of_travel }}</td>
                  <td>{{ item.destination }}</td>
                  <td>{{ item.starting_city }}</td>
                  <td>{{ item.departure_date | parseTime }}</td>
                  <td>{{ item.return_date | parseTime }}</td>
                  <td class="text-center">{{ item.adult }}</td>
                  <td class="text-center">{{ item.children }}</td>
                  <td>IDR {{ digitGrouping(item.budget_per_person) }}</td>

                  <td>
                    <a class="btn btn-block btn-primary btn-xs"
                      @click.prevent="view(item.id)">
                      View
                    </a>
                  </td>
                </tr>
              </tbody>
            </transition>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>

    <transition name="slideDown">
      <modal title="Plan My Trip Detail" v-if="modalVisible">
        <div class="table-responsive" v-if="requestData">
          <table id="table" class="table table-bordered table-striped">
            <tbody>
              <tr>
                <td>Tanggal</td>
                <td>{{ parseDate(requestData.created_at) }}</td>
              </tr>

              <tr>
                <td>Destinasi</td>
                <td>{{ requestData.destination }}</td>
              </tr>

              <tr>
                <td>Kota</td>
                <td>{{ requestData.starting_city }}</td>
              </tr>

              <tr>
                <td>Tanggal Berangkat</td>
                <td>{{ parseDate(requestData.departure_date) }}</td>
              </tr>

              <tr>
                <td>Tanggal Kembali</td>
                <td>{{ parseDate(requestData.return_date) }}</td>
              </tr>

              <tr>
                <td>Dewasa</td>
                <td>{{ requestData.adult }}</td>
              </tr>

              <tr>
                <td>Anak-anak</td>
                <td>{{ requestData.children }}</td>
              </tr>

              <tr>
                <td>Tipe Travel</td>
                <td>{{ requestData.type_of_travel }}</td>
              </tr>

              <tr>
                <td>Makanan</td>
                <td>
                  Sarapan: {{ requestData.breakfast | yesNo }} |
                  Makan Siang: {{ requestData.lunch | yesNo }} |
                  Makan Malam: {{ requestData.dinner | yesNo }}
                </td>
              </tr>

              <tr>
                <td>Pesawat</td>
                <td>{{ requestData.flight | yesNo }}</td>
              </tr>

              <tr>
                <td>Bintang Hotel</td>
                <td>{{ requestData.hotel_star }}</td>
              </tr>

              <tr>
                <td>Anggaran</td>
                <td>IDR {{ digitGrouping(requestData.budget_per_person) }}</td>
              </tr>

              <tr>
                <td>Aktifitas</td>
                <td>{{ requestData.activity }}</td>
              </tr>

              <tr>
                <td>Permintaan Khusus</td>
                <td>{{ requestData.request }}</td>
              </tr>

              <tr>
                <td>Nama</td>
                <td>{{ requestData.full_name }}</td>
              </tr>

              <tr>
                <td>Email</td>
                <td>{{ requestData.email }}</td>
              </tr>

              <tr>
                <td>Telepon</td>
                <td>{{ requestData.phone }}</td>
              </tr>

            </tbody>
          </table>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import moment from 'moment';
import bus from '@/utils/bus';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'RequestsIndex',

  mixins: [Common],

  data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      modalVisible: false,
      requestData: null,
    };
  },

  components: {
    Modal,
    Pagination,
  },

  filters: {
    yesNo(value) {
      if (!value) return 'No';
      return 'Yes';
    },

    parseTime(date) {
      if (!date) return '';
      return moment(date).format('DD MMM YYYY');
    },
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page;

      const params = {
        page: page || pageQuery,
      };

      this.axios.get('/customrequests', { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            return;
          }

          this.items = data;
          this.pagination = meta.pagination;
          this.isLoading = false;
        })
        .catch(() => {
          this.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch custom request data',
            type: 'warning',
            timer: 5000,
          });
        });

      if (page) {
        window.history.pushState(`Custom request page: ${page}`, null, `/requests?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    parseDate(date) {
      return moment(date).format('DD MMMM YYYY');
    },

    showModal() {
      this.$store.commit('SET_MODAL', 'plan');
      this.modalVisible = true;
      document.body.classList.add('locked');
    },

    closeModals() {
      this.modalVisible = false;
      document.body.classList.remove('locked');
    },

    view(id) {
      this.axios.get(`/customrequests/${id}`)
        .then((response) => {
          this.requestData = response.data.data;
          this.showModal();
        })
        .catch((e) => {
          console.log('Error', e);
        });
    },
  },

  created() {
    this.fetch();
  },

  mounted() {
    bus.$on('close-modal', () => {
      this.closeModals();
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style scoped>
  .slideDown-enter-active,
  .slideDown-leave-active {
    transition: all .5s;
  }

  .slideDown-enter,
  .slideDown-leave-to {
    top: -50px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/requests/Index.vue